<template>
  <div class="memberList pages">

    <el-header height="100px">
      <div class="pageTitle">
        <h3>{{ $t("memberlist.emp_list") }}</h3>
        <el-button type="success"
                   style="float:right;margin-top:-20px;"
                   @click="openCreateFun">{{
                $t("memberlist.newAccout")
              }}</el-button>
      </div>
      <div class="condition">
        <div class="condition-cnt">
          <div class="username filterContent">
            <span class="label_name">{{ $t("memberlist.ac_name") }}</span>
            <el-input :placeholder="$t('memberlist.filter_name')"
                      @keyup.enter.native="query"
                      v-model="searchInfo.keyword">
              <i slot="suffix"
                 class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>

          <div class="status filterContent">
            <span class="label_name">{{ $t("memberlist.status") }}</span>
            <el-select v-model="searchInfo.state"
                       :placeholder="$t('memberlist.p_select')"
                       @change="query" >
              <el-option v-for="item in status"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="department filterContent">
            <span class="label_name">{{ $t("memberlist.department") }}</span>
            <wlTreeSelect :defaultExpandAll="false"
                          :placeholder="$t('memberlist.p_select')"
                          width="220"
                          :data="departments"
                          @change="hindleChanged"
                          v-model="selected"></wlTreeSelect>
          </div>

          <div class="_btnCnt filterContent">
            <el-button type="primary"
                       @click="query">{{
                $t("memberlist.query")
              }}</el-button>
            <el-button type="primary"
                       @click="resetCon">{{
                $t("memberlist.clear")
              }}</el-button>
          </div>
        </div>

      </div>
    </el-header>
    <el-main class="table">
      <x-table ref="mt"
               :tableData="tableData"
               :key="$route.fullPath + new Date()"
               :tabheight="tabheight"
               :tableHeader="tableHeader"
               :loading="loading"
               :isshow="isshow"></x-table>

      <x-pagination @pageChanged="onPageChanged"></x-pagination>
    </el-main>

    <el-dialog :title="title[submitStep]"
               :visible.sync="dialogVisible"
               width="60%"
               :before-close="handleClose">
      <!-- :rules="rules" -->
      <el-form :model="userInfo"
               ref="userInfo"
               :label-position="lp"
               :label-width="lw"
               class="demo-ruleForm">
        <el-form-item :label="$t('memberlist.name')"
                      prop="username"
                      class="formItem"
                      :rules="rules.username">
          <el-input v-model="userInfo.username"
                    :placeholder="$t('memberlist.srxm')"
                    :disabled="edit"></el-input>
        </el-form-item>

        <el-form-item :label="$t('memberlist.gender')"
                      prop="gender"
                      class="formItem"
                      required>
          <el-radio-group v-model="userInfo.gender">
            <el-radio :label="0"
                      :disabled="edit">{{
              $t("memberlist.male")
            }}</el-radio>
            <el-radio :label="1"
                      :disabled="edit">{{
              $t("memberlist.female")
            }}</el-radio>
            <el-radio :label="2"
                      :disabled="edit">{{$t('memberlist.confidential')}}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item :label="$t('memberlist.pass_card')"
                      prop="account"
                      class="formItem"
                      :rules="rules.account">
          <el-input v-model="userInfo.account"
                    :placeholder="$t('login.userName')"
                    :disabled="edit"
                    @blur="setDefaultGmail()"
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('memberlist.join_time')"
                      prop="entry_date"
                      class="formItem">
          <el-date-picker type="date"
                          :placeholder="$t('memberlist.p_select')"
                          :disabled="edit"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          v-model="userInfo.entry_date"
                          style="width: 100%;"></el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('memberlist.department')"
                      prop="depart_id_beisen"
                      class="formItem"
                      :rules="rules.depart_id_beisen">
          <wlTreeSelect :defaultExpandAll='false'
                        width="400"
                        :data="departments"
                        :placeholder="$t('memberlist.p_select')"
                        v-model="new_select"
                        @change="newChanged"
                        v-show="!edit"></wlTreeSelect>
          <span v-show="edit">{{ new_select && new_select[0] && new_select[0].name_path}}</span>
        </el-form-item>

        <el-form-item :label="$t('memberlist.position')"
                      prop="job_id"
                      class="formItem">

          <el-select v-model="userInfo.job_id"
                     style="width: 100%;"
                     filterable
                     :placeholder="$t('memberlist.p_select')"
                     :disabled="edit">
            <el-option v-for="item in jobs"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>

        </el-form-item>
        <!-- 直接上级 | supervisor_account -->
        <el-form-item :label="$t('memberlist.supervisor_account')"
                      prop="supervisor_account"
                      class="formItem">
          <el-select v-model="userInfo.supervisor_account"
                     style="width: 100%;"
                     :placeholder="$t('memberlist.p_select')"
                     filterable
                     remote
                     clearable
                     :remote-method="remoteMethod"
                     :loading="remoteLoading"
                     no-match-text="没有匹配到数据"
                     :disabled="edit">
            <el-option v-for="item in options"
                       :key="item.account"
                       :label="item.account"
                       :value="item.account">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('memberlist.creat_email')"
                      prop="creat_email"
                      class="formItem">
          <el-radio-group v-model="userInfo.creat_email" @change="setDefaultGmail()">
            <el-radio :label="0"
                      :disabled="edit">{{
              $t("memberlist.no_creat_email")
            }}</el-radio>
            <el-radio :label="1"
                      :disabled="edit">{{
              $t("memberlist.yes_creat_email")
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="userInfo.creat_email == 0">
          <el-form-item :label="$t('memberlist.google_email')"
                        prop="google_email"
                        :rules="rules.google_email"
                        class="formItem">
            <el-input :placeholder="$t('memberlist.google_email_tip')"
                      :disabled="edit"
                      v-model="userInfo.google_email">
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="resetForm('userInfo')"
                   v-show="submitStep === 1">{{
          $t("memberlist.cancel")
        }}</el-button>
        <el-button @click="backEdit('userInfo')"
                   v-show="submitStep === 2">{{
          $t("memberlist.back")
        }}</el-button>
        <el-button @click="nextEdit('userInfo')"
                   v-show="submitStep === 3">{{
          $t("memberlist.add_new")
        }}</el-button>

        <el-button type="primary"
                   @click="confirmForm('userInfo')"
                   v-show="submitStep === 1">{{ $t("memberlist.next") }}</el-button>
        <el-button type="primary"
                   @click="submitForm('userInfo')"
                   v-show="submitStep === 2">{{ $t("memberlist.next") }}</el-button>
        <el-button type="primary"
                   @click="resetForm('userInfo')"
                   v-show="submitStep === 3">{{ $t("memberlist.close") }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="$t('memberlist.reset_psw')"
               :visible.sync="pswVisible"
               width="30%"
               center
               :before-close="passClose">
      <el-form :model="pswInfo"
               ref="pswInfo"
               :rules="passRules"
               class="psw">
        <el-form-item>
          <el-row :gutter="20">
            <el-col :span="5">Passport</el-col>
            <el-col :span="15">
              {{userAccount}}
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item prop="password">
          <el-row :gutter="20">
            <el-col :span="5">{{$t('memberlist.psw')}}</el-col>
            <el-col :span="15">
              <el-input v-model="pswInfo.password"></el-input>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item prop="checkPass">
          <el-row :gutter="20">
            <el-col :span="5">{{$t('memberlist.c_psw')}}</el-col>
            <el-col :span="15">
              <el-input v-model="pswInfo.checkPass"></el-input>
            </el-col>
          </el-row>

        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="resetCancel('pswInfo')">{{
          $t("memberlist.cancel")
        }}</el-button>
        <el-button type="primary"
                   @click="resetSure">{{
          $t("memberlist.confirm")
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('memberlist.send_m')"
               :visible.sync="sendMVisible"
               width="30%"
               center>
      <el-form
               class="psw">
        <el-form-item>
          <el-row :gutter="20">
            <el-col :span="5"><b>Passport</b></el-col>
            <el-col :span="15">
              {{userAccount}}
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-row :gutter="20">
            <el-col :span="5"><b>Email</b></el-col>
            <el-col :span="15">
              {{userEmail}}
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-row :gutter="20">
            <el-col :span="5"></el-col>
            <el-col :span="15" style="width: 90%">
              {{$t('memberlist.send_m_tips')}}
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="cancelSendMail()">{{
            $t("memberlist.cancel")
          }}</el-button>
        <el-button type="primary"
                   @click="sendExmailByIdAccount(sendMInfo.id,sendMInfo.account)">{{
            $t("memberlist.confirm")
          }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import xTable from "@/components/x-table.vue";
import xPagination from "@/components/pagination/index.vue";
import pagination from "@/components/pagination/index.js";
import validators from "@/utils/validator.js";
import { memberList, create, checkInfo, searchByAccount } from "@/api/api.js";
import { mapGetters } from "vuex";
import _ from "lodash";
import {sendExmailByIdAccountTwo} from "../api/api";

export default {
  name: "memberList",
  components: { xTable, xPagination },
  mixins: [pagination, validators],
  data() {
    return {
      props: {
        label: "name",
        value: "id"
      },
      treeData: [],
      selected: [],
      new_select: [],
      searchInfo: {
        state: 1,
        utime: "",
        entry_date: ""
      },
      loading: false,
      isshow: false,
      tabheight: "100%",
      tableData: [],
      dialogVisible: false,
      edit: false,
      pswInfo: {
        password: "",
        account: ""
      },
      pswVisible: false,
      submitStep: 1,
      userAccount: "",
      userEmail: "",
      sendMInfo: {
        id: 0,
        account: ""
      },
      sendMVisible: false,
      lp: "left",
      remoteLoading: false,
      keyWord: "",
      options: []
    };
  },
  computed: {
    ...mapGetters(["lang"]),
    lw() {
      return "120px";
    },
    tableHeader() {
      let that = this;
      return [
        { prop: "id", label: "ID", width: "60px" },
        {
          prop: "account",
          label: this.$t("memberlist.pass_card"),
          width: "140px"
        },
        {
          prop: "username",
          label: this.$t("memberlist.full_name"),
          width: "100px"
        },
        {
          prop: "email",
          label: this.$t("memberlist.email"),
        },
        { prop: "job_name", label: this.$t("memberlist.position"),width: "160px" },
        {
          prop: "depart_name",
          label: this.$t("memberlist.department"),
          title: "depart_name_path",
          width: "160px"
        },
        {
          prop: "supervisor_account",
          label: this.$t("memberlist.supervisor_account"),
          width: "140px"
        },
        {
          prop: "entry_date",
          label: this.$t("memberlist.entry_date"),
          width: "100px"
        },
        {
          prop: "state",
          label: this.$t("memberlist.status"),
          formatData: function (val) {
            return val == 1
              ? `<strong style="color: #31a354">${that.$t(
                  "memberlist.active"
                )}</strong>`
              : `<strong style="color: #F56C6C">${that.$t(
                  "memberlist.suspended"
                )}</strong>`;
          },
          width: "90px"
        },
        {
          prop: "oper",
          label: this.$t("memberlist.action"),
          fixed: "right",
          minWidth: "80px",
          oper: [
            {
              name: this.$t("memberlist.reset_pwd"),
              style: "danger",
              clickFun: this.resetClick
            },
            {
              name: this.$t("memberlist.details"),
              style: "primary",
              clickFun: this.detailClick
            },
            {
              name: this.$t("memberlist.send_m"),
              style: "",
              clickFun: this.sendMailClick
            }
          ]
        }
      ];
    },
    status() {
      return [
        { label: this.$t("memberlist.all_status"), value: "" },
        { label: this.$t("memberlist.active"), value: 1 },
        { label: this.$t("memberlist.suspended"), value: 2 },
        { label: this.$t("memberlist.locked"), value: 3 }
      ];
    },
    title() {
      return [
        "",
        this.$t("memberlist.newAccout"),
        this.$t("memberlist.c_accout"),
        this.$t("memberlist.addsuccess_title")
      ];
    }
  },
  methods: {
    openCreateFun() {
      this.dialogVisible = true;
      this.userInfo.google_email = "";
    },
    setDefaultGmail() {
      //console.log('触发同步至谷歌mail输入框');
      let params = this.userInfo;
      if (params.creat_email == 0) {
        //console.log('获取account-->同步至谷歌mail输入框');
        //console.log(params);
        if (params.account.length > 0) {
          this.userInfo.google_email = params.account + '@lalamove.com';
        } else {
          this.userInfo.google_email = '';
        }
      } else {
        this.userInfo.google_email = '';
      }
    },
    remoteMethod(searchKey) {
      //输入值发生变化时的回调函数
      if (searchKey !== "") {
        this.remoteLoading = true;
        this.keyWord = searchKey;
        this.getRemote();
      } else {
        this.options = [];
      }
    },
    getRemote: _.debounce(function () {
      //防抖，这里设置300毫秒请求一次后台
      console.log(this.keyWord);
      this.searchByAccount({
        keyword: this.keyWord
      });
    }, 300),
    async searchByAccount(params) {
      let res = await searchByAccount(params);
      this.remoteLoading = false;
      this.options = res?.list.map((item) => ({
        account: item.account,
        username: `${item.username}(${item.account})`
      }));
    },
    query() {
      // this.pagination.per_page = 10;
      // this.pagination.page = 1;
      this.getMemberList();
    },
    resetCon() {
      this.searchInfo = {
        utime: "",
        entry_date: ""
      };
      this.selected = [];
      this.pagination.per_page = 10;
      this.pagination.page = 1;
      this.getMemberList();
    },
    resetClick(info) {
      this.userAccount = info.account;
      this.pswVisible = true;
      (this.pswInfo = {
        password: "",
        account: "",
        checkPass: ""
      }),
        (this.random = "");
    },
    sendMailClick(info) {
      this.userAccount = info.account;
      this.userEmail = info.email;
      this.sendMVisible = true;
      // console.log(info); return false;
      (this.sendMInfo = {
        id: info.id,
        account: info.account,
      }),
          (this.random = "");
    },
    detailClick(user) {
      let routeData = this.$router.resolve({
        name: "memberDetail",
        params: { user: user.account, id: user.id }
      });
      window.open(routeData.href, "_blank");
    },
    confirmForm(formName) {
      // this.userInfo.email = this.userInfo.account;
      // this.userInfo.phone_code += "";

      let params = this.userInfo;

      this.$refs[formName].validate((valid) => {
        if (valid) {
          checkInfo(params).then(() => {
            this.edit = true;
            this.submitStep = 2;
          });
        } else {
          return false;
        }
      });
    },
    submitForm() {
      // this.userInfo.email = this.userInfo.account;
      // create
      let params = {
        ...this.userInfo,
        google_email:
          this.userInfo.creat_email == 0 ? this.userInfo.google_email : ""
      };
      create(params).then((res) => {
        //console.log(res, 999999)
        if (res?.sendEmailUrl) {
          console.log('recall to send mail')
          sendExmailByIdAccountTwo(res?.sendEmailUrl).then((resp) => {
            console.log('send mail status:'+resp.status)
          }).catch((ex) => {
            console.log(ex)
          })
        } else {
          //err
        }
        //
        this.$message({
          message: this.$t("memberlist.success_add"),
          type: "success"
        });
        this.submitStep = 3;
      }).catch(e => {
        console.log(e)
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.new_select = [];
      this.submitStep = 1;
      this.dialogVisible = false;
      this.edit = false;
      this.getMemberList();
      // this.userInfo.phone_code = "86";
    },
    backEdit() {
      this.edit = false;
      this.submitStep = 1;
    },
    nextEdit(formName) {
      this.$refs[formName].resetFields();
      this.new_select = [];
      this.submitStep = 1;
      this.edit = false;
    },

    handleClose() {
      this.resetForm("userInfo");
    },
    getMemberList() {
      this.searchInfo.utime || (this.searchInfo.utime = []);
      this.searchInfo.entry_date || (this.searchInfo.entry_date = []);
      const params = this.addPageInfo(this.searchInfo);
      let _this = this;
      _this.loading = true;
      memberList(params).then((res) => {
        _this.tableData = res.list;
        _this.onGotPageData(res);
        _this.loading = false;
      });
      this.ucWatermark();
    }
  },
  activated() {
    this.getMemberList();
  }
};
</script>
<style lang="less">
.memberList {
  .el-form-item__label {
    padding: 0 !important;
  }
}
</style>
<style scoped lang="less">
.memberList {
  .el-header {
    height: auto !important;
    border-bottom: 1px dashed #909399;
    padding: 0;
  }
  .condition {
    margin-top: 20px;
    .condition-cnt {
      position: relative;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
    }
    .label_name {
      padding: 0px 10px 0px 20px;
      max-width: 86px;
      box-sizing: border-box;
      display: inline-block;
    }
    .filterContent {
      margin-bottom: 15px;
      margin-right: 15px;
    }
    .el-input,
    .el-select {
      width: 240px;
    }
  }
  .el-form-item {
    min-width: 300px;
  }
  .formItem {
    display: inline-block;
    width: 45%;
    &:nth-child(even) {
      float: right;
    }
    &:nth-child(odd) {
      width: 50%;
    }
    .wl-tree-select {
      width: 100% !important;
    }
  }
  tr {
    .is-hidden {
      display: table-cell;
      overflow: hidden;
    }
  }
  ._btnCnt {
    display: flex;
    justify-content: flex-end;
    width: 140px !important;
    height: 30px;
    margin-right: 0px !important;
    position: absolute;
    right: 0;
  }
  .randomPsw {
    height: 28px;
    line-height: 28px;
    background-color: #f5f7fa;
    border: 1px solid #e4e7ed;
    color: #c0c4cc;
    border-radius: 5px;
    margin-top: 5px;
    padding-left: 10px;
  }
}
</style>
